import { useEffect, useState } from "react"

const MOBILE_BREAKPOINT = 768

const checkIsMobile = () => Math.min(window.innerWidth, window.innerHeight) < MOBILE_BREAKPOINT

export function useIsMobile() {
  const [isMobile, setIsMobile] = useState(checkIsMobile())

  useEffect(() => {
    const handleChange = () => {
      setIsMobile(checkIsMobile())
    }
    window.addEventListener("resize", handleChange)
    window.addEventListener("orientationchange", handleChange)
    return () => {
      window.removeEventListener("resize", handleChange)
      window.removeEventListener("orientationchange", handleChange)
    }
  }, [])

  return isMobile
}
